module.exports = __webpack_public_path__ + "static/media/twitter.23e7229f.png";